import React from "react"
import { LayoutSubjectSpotlight } from "trimble-terra"
import { Link } from "gatsby"
import formatPageLinks from "../formatPageLinks"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatThemePreset } from "../formatTheme"

const FormatAndRenderLayoutSubjectSpotlight = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const configuration = {
    eyebrow: data?.eyebrow,
    header: data?.header,
    subheader: data?.subheader?.subheader,
    description: <RichTextConnector data={{ content: data?.description }} />,
    foregroundImage: {
      url: data?.spotlightImage?.image?.file?.url,
      alt: data?.spotlightImage?.altText,
    },
    presetTheme: formatThemePreset(data?.theme),
    isHeaderBig: data?.isHeaderBig || false,
    buttons: data?.buttons?.map(button => {
      const formattedButton = formatPageLinks(
        button,
        locale,
        button?.url?.__typename,
        homepageSlug,
        currentSpaceId,
        siteIdentifier
      )
      return {
        ...button,
        label: formattedButton?.text,
        destination: formattedButton?.url,
        primary: button?.isPrimary,
        Link: Link,
      }
    }),
  }

  return <LayoutSubjectSpotlight isWrapped={true} {...configuration} />
}

export default FormatAndRenderLayoutSubjectSpotlight
